import { render, staticRenderFns } from "./NPFView.vue?vue&type=template&id=492ffe2b&scoped=true&"
import script from "./NPFView.vue?vue&type=script&lang=ts&"
export * from "./NPFView.vue?vue&type=script&lang=ts&"
import style0 from "./NPFView.vue?vue&type=style&index=0&id=492ffe2b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492ffe2b",
  null
  
)

export default component.exports